<template>
  <div class="pl-3 pt-3 pb-2 bg-light-fracture1 rounded-top">
    <h4 class="modal-title">写真備考表示・編集</h4>
  </div>
  <div class="p-3">
    <el-form ref="photoMemoForm" @submit.prevent :rules="rules" :model="memoModel"  label-position="top">
      <el-form-item prop="memo">
        <el-input
          placeholder="テキストで入力"
          clearable
          type="textarea"
          v-model="memoModel.memo"
        ></el-input>
      </el-form-item>
    </el-form>

    <div class="d-flex mt-4">
      <div class="my-box flex-fill pr-1">
        <base-button
          block
          type="secondary"
          @click="onClickCancel"
          v-if="!isNewProject"
          >キャンセル</base-button
        >
      </div>
      <div class="my-box flex-fill pl-1">
        <base-button
          block
          type="primary"
          @click="onClickSave"
          v-if="!isNewProject"
          >OK</base-button
        >
      </div>
    </div>
  </div>
</template>

<style>
</style>
<script>

import ValidateUtil from "@/appUtils/ValidateUtil"
import { useToast } from "vue-toastification";

export default {
  components: {
  },
  props: {
    memo: String,
    filePath: String,
    index: Number,
    mode: Number,
  },
  data() {
    return {
      memoModel: {
        memo: "",
      },
      rules: {
        memo: [{required: false, validator: this.checkMemo, trigger: 'blur'}]
      },
      toastId: "photoMemo",
    };
  },
  beforeCreate() {
    //インスタンスは生成されたがデータが初期化される前
  },
  created() {

  },
  beforeMount() {
    //インスタンスが DOM 要素にマウントされる前
  },
  mounted() {
    //インスタンスが DOM 要素にマウントされた後
    this.init().then(() => {
      console.log(`init end`)
    })
  },
  beforeUpdate() {
    //データは更新されたが DOM に適用される前
  },
  updated() {
    //データが更新され､且つ DOM に適用された後
  },
  beforeUnmount() {
    //Vue インスタンスが破壊される前
  },
  unmounted() {
    //Vue インスタンスが破壊された後
  },
  //ボタンイベントなどのメソッドはmethodsに
  methods: {
    async init() {
      this.memoModel.memo = this.memo
    },
    onClickCancel() {
      this.$emit('photoMemoCancel')
    },
    async onClickSave() {
      try {
        this.$refs.photoMemoForm.validate(async function(result) {
          if (!result) {
            this.runToast("入力内容にエラーがあります。", "error")
            return
          }

          this.$emit('photoMemoSave', this.memoModel.memo, this.filePath, this.index, this.mode)
        }.bind(this))

      } catch (e) {
        console.log(e.stack)
        this.runToast("写真備考の保存時にエラーが発生しました。", "error")
        this.$emit('photoMemoCancel')
      }
    },

    /**
     * 箇所名の入力チェック
     */
    async checkMemo(rule, value, callback){
      if (ValidateUtil.checkBase(value, callback, 100, false, false, false, true)) {
        callback()
      }
    },

    // ----------------
    // トースト
    // ----------------
    /**
     * トースト表示
     */
    runToast(message, type) {
      const pos = 'bottom-center'
      const toast = useToast();

      toast[type](message, {
        hideProgressBar: true,
        icon: false,
        toastClassName: ["custome-toast-class"],
        closeButton: false,
        position: pos,
        id: this.toastId
      });
    },

    /**
     * トースト非表示
     */
    hideToast() {
      const toast = useToast();
      toast.dismiss(this.toastId)
    },
  }
};
</script>
